import { useEffect, useState } from 'react'
import { api, session } from '../api.js'

export default function MonCompte() {
  const [profil, setProfil] = useState(null)
  const [message, setMessage] = useState('')
  const [erreur, setErreur] = useState('')
  const [mdp, setMdp] = useState({ actuel: '', nouveau: '', confirmation: '' })

  useEffect(() => { api.profile().then(setProfil).catch((e) => setErreur(e.message)) }, [])
  if (!profil) return <p className="chargement">{erreur || 'Chargement…'}</p>

  async function sauver(champs) {
    try {
      await api.saveProfile(champs)
      setProfil({ ...profil, ...champs })
      setMessage('Enregistré.'); setErreur('')
    } catch (e) { setErreur(e.message) }
  }

  async function changer(e) {
    e.preventDefault()
    if (mdp.nouveau !== mdp.confirmation) {
      setErreur('Les deux nouveaux mots de passe ne sont pas identiques.')
      return
    }
    try {
      const r = await api.changePassword({ actuel: mdp.actuel, nouveau: mdp.nouveau })
      setMdp({ actuel: '', nouveau: '', confirmation: '' })
      setMessage(r.message); setErreur('')
    } catch (e) { setErreur(e.message) }
  }

  return (
    <>
      <h1>Mon compte</h1>
      <p className="chapo">Vos informations et votre mot de passe.</p>
      {message && <p className="succes" role="status">{message}</p>}
      {erreur && <p className="erreur" role="alert">{erreur}</p>}

      <div className="deux">
        <section className="carte">
          <h2>Vos informations</h2>
          <div className="champ">
            <label htmlFor="p-nom">Nom et prénom</label>
            <input id="p-nom" defaultValue={profil.name}
                   onBlur={(e) => e.target.value !== profil.name && sauver({ name: e.target.value })} />
            <p className="aide">C'est ce nom qui apparaît au registre des dossiers que vous traitez.</p>
          </div>
          <div className="champ">
            <label htmlFor="p-mail">Adresse électronique</label>
            <input id="p-mail" type="email" defaultValue={profil.email}
                   onBlur={(e) => e.target.value !== profil.email && sauver({ email: e.target.value })} />
            <p className="aide">Elle sert à vous connecter.</p>
          </div>
        </section>

        <aside>
          <div className="carte">
            <h2>Votre rôle</h2>
            <p className="role-titre">{profil.role.label}</p>
            <p className="aide">{profil.role.description}</p>
            <p className="aide">Dans : {profil.org}</p>
            <p className="aide">Pour en changer, demandez à un responsable de votre collectivité.</p>
          </div>

          <form className="carte" onSubmit={changer}>
            <h2>Changer de mot de passe</h2>
            <div className="champ">
              <label htmlFor="m-act">Mot de passe actuel</label>
              <input id="m-act" type="password" autoComplete="current-password" required
                     value={mdp.actuel} onChange={(e) => setMdp({ ...mdp, actuel: e.target.value })} />
            </div>
            <div className="champ">
              <label htmlFor="m-new">Nouveau mot de passe</label>
              <input id="m-new" type="password" autoComplete="new-password" minLength={8} required
                     value={mdp.nouveau} onChange={(e) => setMdp({ ...mdp, nouveau: e.target.value })} />
              <p className="aide">Huit caractères au minimum.</p>
            </div>
            <div className="champ">
              <label htmlFor="m-conf">Répétez le nouveau</label>
              <input id="m-conf" type="password" autoComplete="new-password" required
                     value={mdp.confirmation}
                     onChange={(e) => setMdp({ ...mdp, confirmation: e.target.value })} />
            </div>
            <button className="btn pri">Changer</button>
          </form>

          <div className="carte">
            <h2>Session</h2>
            <p className="aide">Vous travaillez sur la version
              {session.env === 'draft' ? ' brouillon' : ' en ligne'}.</p>
            <button className="btn" onClick={() => { session.clear(); window.location.reload() }}>
              Se déconnecter
            </button>
          </div>
        </aside>
      </div>
    </>
  )
}
